/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import './index.scss';

import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import axios from 'axios';
import { BrowserRouter } from 'react-router';

import { LoggingHelper } from 'sarsaparilla';

import { ExternalAppProviders } from 'shared-ui/external-app-base';
import { RestoreScroll } from 'shared-ui/components/RestoreScroll/RestoreScroll';

import { store } from './store';

import App from './App';

axios.defaults.headers.common.Pragma = 'no-cache';

const root = createRoot(document.getElementById('recApp') as HTMLElement);

root.render(
    <Provider store={store}>
        <ExternalAppProviders>
            <BrowserRouter>
                <RestoreScroll />
                <App />
            </BrowserRouter>
        </ExternalAppProviders>
    </Provider>
);

if (process.env.NODE_ENV !== 'development') {
    // intercept and log all uncaught system errors
    const onError = (
        msg: string | Event,
        url: string | undefined,
        line: number | undefined,
        col: number | undefined,
        error: Error | undefined
    ) => {
        let extra = !col ? '' : `\ncolumn: ${col}`;
        extra += !error ? '' : `\nerror: ${error}`;
        const message = `Error: ${msg}\nurl: ${url}\nline: ${line}${extra}`;
        LoggingHelper.logError(message);
        return true;
    };

    window.onerror = onError;
}
